// WhyChooseUsSection.jsx
// Desktop: left image + right content with 2-col dark cards
// Mobile: stacked - dark cards first, then image below
// import img1 from "../Assests/why-choose-us-image.jpg"
import img1 from "../Assests/AboutUs/SDS_0404.JPG"

const IMG_GIRL_ART = "https://thumbs.dreamstime.com/b/portrait-happy-little-indian-asian-boy-208111421.jpg";
const IMG_ATTENTION = "https://t4.ftcdn.net/jpg/14/24/51/47/360_F_1424514793_85CPo5TDaV9OnDuAgxcxoloROK0NFWlv.jpg";
const IMG_SNACKS = "https://yourcommonwealth.org/wp-content/uploads/2024/12/Indian-Girl-Child-copy.jpg";

const AvatarPair = ({ src1, src2 }) => (
  <div className="flex justify-center mb-4">
    <div className="relative flex">
      <img src={src1} alt="" className="w-14 h-14 rounded-full object-cover border-4 border-[#2a3a52] z-10" />
      <img src={src2} alt="" className="w-14 h-14 rounded-full object-cover border-4 border-[#2a3a52] -ml-4" />
    </div>
  </div>
);

const PillTag = ({ label }) => (
  <span className="inline-flex items-center gap-1 border border-gray-500 rounded-full px-3 py-1 text-xs font-semibold text-gray-300">
    <span className="text-[#FF6B35] text-sm font-black">✦</span>
    {label}
  </span>
);

export default function WhyChooseUsSection() {
  return (
    <section className="w-full bg-[#0D1B2A] py-14 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-10 items-start">

        {/* LEFT: Image with contact card overlay - hidden on mobile, shown below */}
        <div className="hidden md:block w-full md:w-1/2 relative">
          <div className="rounded-2xl overflow-hidden shadow-2xl">
            <img
              src={img1}
              alt="Girl painting"
              className="w-full h-[500px] object-cover"
            />
          </div>

          {/* Contact card overlay */}
          <div className="absolute bottom-6 left-6 bg-white rounded-2xl shadow-xl p-5 w-60">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-[#FF6B35] flex items-center justify-center flex-shrink-0">
                <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5" stroke="white" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.09 11a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div>
                <p className="text-xs text-gray-400 font-semibold">Call Us!</p>
                <p className="text-sm font-extrabold text-[#0D1B2A]">+91-7618759333</p>
              </div>
            </div>
            {/* <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-[#FF6B35] flex items-center justify-center flex-shrink-0">
                <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5" stroke="white" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" strokeLinecap="round" strokeLinejoin="round" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div>
                <p className="text-xs text-gray-400 font-semibold">Email Us!</p>
                <p className="text-sm font-extrabold text-[#0D1B2A]">info@domin.com</p>
              </div>
            </div> */}
          </div>
        </div>

        {/* RIGHT: Content */}
        <div className="w-full md:w-1/2">
          {/* Label */}
          <div className="inline-flex items-center gap-2 border border-gray-600 rounded-full px-4 py-1 text-sm font-medium text-gray-300 mb-5 bg-[#1a2a3a]">
            <span className="text-[#FF6B35] font-black text-lg">✦</span>
            Why Choose Us
          </div>

          <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight mb-4">
            Why parents choose us 
            {/* for their child's growth */}
          </h2>
          <p className="text-gray-400 text-sm leading-relaxed mb-8">
            We provide an inspiring space where children discover new skills, build confidence, and enjoy learning through hands-on activities.
          </p>

          {/* Feature Cards 2-col grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

            {/* Card: Individual Attention */}
            <div className="bg-[#1a2a3a] rounded-2xl p-5">
              <AvatarPair src1={IMG_ATTENTION} src2={IMG_GIRL_ART} />
              <h3 className="text-white font-extrabold text-base mb-2">Individual Attention</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                We ensure every child receives the care, guidance.
              </p>
              <div className="flex flex-wrap gap-2">
                <PillTag label="Learning" />
                <PillTag label="Growth" />
              </div>
            </div>

            {/* Card: Healthy Snacks */}
            <div className="bg-[#1a2a3a] rounded-2xl p-5">
              <AvatarPair src1={IMG_SNACKS} src2={IMG_ATTENTION} />
              <h3 className="text-white font-extrabold text-base mb-2">Healthy Meals</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                We ensure every child receives the care, guidance.
              </p>
              <div className="flex flex-wrap gap-2">
                <PillTag label="Learning" />
                <PillTag label="Growth" />
              </div>
            </div>
          </div>
        </div>

        {/* Mobile: image shown below content */}
        <div className="md:hidden w-full relative">
          <div className="rounded-2xl overflow-hidden shadow-2xl">
            <img
              src={img1}
              alt="Girl painting"
              className="w-full h-72 object-cover"
            />
          </div>
          {/* Contact card - mobile */}
          <div className="mt-4 bg-white rounded-2xl shadow-xl p-5">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-[#FF6B35] flex items-center justify-center flex-shrink-0">
                <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5" stroke="white" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.09 11a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div>
                <p className="text-xs text-gray-400 font-semibold">Call Us!</p>
                <p className="text-sm font-extrabold text-[#0D1B2A]">+91-7618759333</p>
              </div>
            </div>
            {/* <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#FF6B35] flex items-center justify-center flex-shrink-0">
                <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5" stroke="white" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" strokeLinecap="round" strokeLinejoin="round" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div>
                <p className="text-xs text-gray-400 font-semibold">Email Us!</p>
                <p className="text-sm font-extrabold text-[#0D1B2A]">info@domin.com</p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
